export const initialState = {
  apiSuccessResponse: {
    create: false,
    update: false,
  },
  siteActivityData: [],
  status: 'idle',
  loading: false,
  siteId: '',
  totalRecords: 0,
  isRecordsFound: false,
  siteActivitySelectedRowData: [],
};
